/* eslint-disable no-undef, prefer-template, max-len, id-length, func-names, prefer-arrow-callback */
// TODO: Un-jQuery-ify this.
document.addEventListener('DOMContentLoaded', () => {
  jQuery(document).ready(($) => {
    /**
     * Update Slick Counts.
     *
     * @param {object} slider slider object.
     * @param {object} slick slick slider object.
     * @param {string} update is updating?
     */
    const updateSlickCount = (slider, slick, update = false) => {
      const count = slick.slideCount; // Total count.
      const current = slick.currentSlide + 1; // Starts index from 0.

      let next = 0;
      let prev = 0;

      // If we're on the last slide.
      // Else if we're on the first slide.
      // Else, assume the normal +1 and -1.
      if (count === current) {
        prev = current - 1;
        next = 1;
      } else if (current === 1) {
        prev = count;
        next = current + 1;
      } else {
        prev = current - 1;
        next = current + 1;
      }

      // On init, no divs yet.
      if (!update && prev !== 0) {
        slider.find('.slick-prev')
          .append(`<div class="slick-counter-prev">${parseInt(prev, 10)}/${count}</div>`); // phpcs:ignore WordPressVIPMinimum.JS.HTMLExecutingFunctions.append
      }
      if (!update && next !== 0) {
        slider.find('.slick-next')
          .append(`<div class="slick-counter-next">${parseInt(next, 10)}/${count}</div>`); // phpcs:ignore WordPressVIPMinimum.JS.HTMLExecutingFunctions.append
      }

      // On updates, div exists.
      if (update && prev !== 0) {
        slider.find('.slick-counter-prev')
          .text(`${parseInt(prev, 10)} / ${count}`);
      }
      if (update && next !== 0) {
        slider.find('.slick-counter-next')
          .text(`${parseInt(next, 10)} / ${count}`);
      }
    };

    /**
     * Position slider dots.
     *
     * @param mixed slider slider instance.
     */
    const positionDots = (slider) => {
      const capHeight = [];
      const captions = slider.find('.wp-block-image figcaption');

      // Bail if we don't have a caption.
      if (!captions) {
        return;
      }

      // Loop through and add caption heights to array.
      captions.map((indx, cap) => capHeight.push($(cap).innerHeight()));

      // Get largest caption height, and return value.
      const capHeightMax = Math.max.apply(null, capHeight);

      if (capHeightMax > 0) {
        // Position slick dots relative to bottom of caption.
        slider.find('.slick-dots')
          .css('marginTop', (capHeightMax + 60) * -1);
      }
    };

    /**
    * Handle Slick slider.
    */
    const initSlickSlider = () => {
      const sliders = $('.slideshow');

      sliders.each((index, item) => {
        const slider = $(item);
        const data = slider.data();

        // Set settings defaults.
        let autoplay = true;
        let arrows = true;
        let autoplaySpeed = 3000;
        let dots = false;

        // Settings from Slideshow Admin.
        if (data) {
          autoplay = data.autoPlay === 1;
          arrows = data.arrows === 1;
          autoplaySpeed = autoplay && data.autoPlaySpeed
            ? data.autoPlaySpeed * 1000 : 3000;
          dots = data.dots === 1;
        }

        // Setup navigation.
        slider.on('init', (e, slick) => {
          updateSlickCount(slider, slick, false);

          positionDots(slider);
        });

        slider.slick({
          arrows,
          autoplay,
          autoplaySpeed,
          centerMode: true,
          dots: false,
          infinite: true,
          prevArrow: '<button type="button" class="slick-prev">Last </button>',
          slidesToShow: 1,
          useTransform: false, // fixes blur issue.
          responsive: [
            {
              breakpoint: 599,
              settings: {
                dots,
              },
            },
          ],
        });

        // Change navigation.
        slider.on('afterChange', (e, slick) => {
          updateSlickCount(slider, slick, true);
        });
      });
    };

    $(window).resize(() => {
      $('.slideshow').each((index, item) => {
        positionDots($(item));
      });
    });

    // Init.
    initSlickSlider();
  });
});
/* eslint-enable no-undef, prefer-template, max-len, id-length */
